import React, { useState } from "react";

import { Link } from "react-router-dom";
import VideoModal from "../../components/others/VideoModal";

const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <section
      id="Inicio"
        className="hero-section pt-100 background-img"
        style={{
          background:
            "url('assets/img/app-hero-bg.jpg')no-repeat center center / cover",
        }}
      >
        <div className="container">
          <div className="row  justify-content-between py-5">
            <div className="col-md-7 col-lg-6">
              <div className="hero-content-left text-white">
                <h1 className="text-white">
                  <span>Reclutamiento Inteligente</span> con IA
                </h1>
                <p className="lead">
                  Optimizamos la atracción y selección de talento para que tu empresa crezca sin limites.
                </p>

              </div>
            </div>
            <div className="col-md-5 col-lg-5">
              <div className="hero-animation-img">
                <img
                  src="assets/img/peopleWaiting.png"
                  alt="app"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <VideoModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </div>
        <div className="bottom-img-absolute">
          <img
            src="assets/img/hero-bg-shape-1.svg"
            alt="wave shape"
            className="img-fluid"
          />
        </div>
      </section>
    </>
  );
};

export default Banner;
